import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import { EntitlementDetails, FetchInvoiceGroupDetailsPpcQuery } from '@css-xp/graphtypes/src/generated-types-new';
import { Usage } from './usage';
import { Plan } from './plan';
import { NextBillDate } from './next-billdate';
import { NextPriceEstimate } from './next-price-estimate';
import { CompanyAndBillingProfile } from './company-billing-profile';

type EntitlementCardsProps = {
  entitlement: EntitlementDetails;
  invoiceGroupDetails: ApolloQueryResult<FetchInvoiceGroupDetailsPpcQuery | undefined>;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
  isGracePeriodVisibilityEnabled?: boolean;
  isMultiInstanceAppsEnabled?: boolean;
};

export const EntitlementCards = ({
  entitlement,
  invoiceGroupDetails,
  refetch,
  isGracePeriodVisibilityEnabled,
  isMultiInstanceAppsEnabled,
}: EntitlementCardsProps) => {
  return (
    <Box paddingBlockEnd="space.300" testId="entitlement-cards-container">
      <Flex gap="space.200">
        <Usage entitlement={entitlement} />
        <Plan entitlement={entitlement} isMultiInstanceAppsEnabled={isMultiInstanceAppsEnabled} />
        <NextBillDate
          entitlement={entitlement}
          refetch={refetch}
          isGracePeriodVisibilityEnabled={isGracePeriodVisibilityEnabled}
        />
        <NextPriceEstimate entitlement={entitlement} isMultiInstanceAppsEnabled={isMultiInstanceAppsEnabled} />
        <CompanyAndBillingProfile entitlement={entitlement} invoiceGroupDetails={invoiceGroupDetails} />
      </Flex>
    </Box>
  );
};
